import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TButton',
};

import { Size, Variant } from '../design-system';
import { useButton } from '~/composables/components/useButton';

interface TButtonProps {
  size?: Size;
  variant?: Variant;
  disabled?: boolean;
  isSubmitting?: boolean;
  icon?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    size: { default: 'default' },
    variant: { default: 'default' },
    disabled: { type: Boolean },
    isSubmitting: { type: Boolean, default: false },
    icon: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { size: Size, variant: Variant, disabled?: boolean, isSubmitting: boolean, icon: string };



const { classes, iconClasses, isDisabled } = useButton(props, 'button');

return { __sfc: true,props, classes, iconClasses, isDisabled }
}

})